import { useEffect } from 'react'

const GTM_CONTAINER_ID = 'GTM-KSCWMSLF'
const SCRIPT_ID = 'google-tag-manager-script'

/**
 * Loads Adalo marketing GTM once on auth routes so `_ga` and related cookies
 * exist for signup attribution (e.g. ga4ClientId) on both login and signup.
 */
export function AdaloMarketingGtm(): null {
  useEffect(() => {
    if (typeof document === 'undefined' || document.getElementById(SCRIPT_ID)) {
      return
    }

    const googleTagManagerScript = `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_CONTAINER_ID}');
`

    const script = document.createElement('script')
    script.setAttribute('id', SCRIPT_ID)
    script.text = googleTagManagerScript
    document.head.appendChild(script)

    const noscript = document.createElement('noscript')
    noscript.setAttribute('id', 'google-tag-manager-body')

    const iframe = document.createElement('iframe')
    iframe.setAttribute(
      'src',
      `https://www.googletagmanager.com/ns.html?id=${GTM_CONTAINER_ID}`
    )
    iframe.setAttribute('height', '0')
    iframe.setAttribute('width', '0')
    iframe.setAttribute('style', 'display:none;visibility:hidden')
    iframe.setAttribute('title', 'google-tag-manager-iframe')

    noscript.appendChild(iframe)
    document.body.appendChild(noscript)
  }, [])

  return null
}
